module.exports = __webpack_public_path__ + "static/media/ATCLogo.caabd761.png";